var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.inScud)?_c('a',{on:{"click":function($event){return _vm.sendScudXml($event, _vm.requireTransport)}}},[_c('img',{staticClass:"icon-pdf",attrs:{"src":_vm.iconPath('v_scud.svg'),"alt":""}}),_vm._v(" "+_vm._s(_vm.sendToScudText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }